import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { BotsService } from '../service';
import { localStorageService } from 'src/services/local-storage.service';
import { CommercialFormValue } from '../useFinishChatForm';
import { filterBotFlow, getOnlyOnChatActionNode } from './helper';

interface UseBotFlowServiceProps {
  commercialType: Omit<CommercialFormValue, 'other'>;
}

export function useBotFlowService({ commercialType }: UseBotFlowServiceProps) {
  const currentCustomer = useSelector(
    (state: any) => state?.chat?.config?.user?.current_customer_id
  ) as number;

  const currentChannelId = useSelector(
    (state: any) =>
      state?.chat?.chats.find((chat: any) => chat.open === true)?.view
        ?.selectedChannel?.id
  ) as number;

  const legacy_token = localStorageService.getLocalStorageItem({
    key: 'user_token_login_info',
  })?.legacy_token;

  const [botFlow, setBotFlow] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const getBotFlow = async () => {
    setIsLoading(true);

    try {
      if (legacy_token && currentCustomer) {
        const response = await BotsService.getBotFlow(
          legacy_token,
          currentCustomer
        );

        const flows = response.map((flow: any) =>
          getOnlyOnChatActionNode(flow)
        );
        setBotFlow(flows);
        setError(false);
      }
    } catch (error) {
      console.error('error get bot flow: ', error);
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const filteredBotFlow = useMemo(() => {
    if (!botFlow) return [];
    // filtrar apenas os fluxos que possuem o tipo de ação igual ao commercialType selecionado
    return filterBotFlow(botFlow, commercialType, currentChannelId);
  }, [botFlow, currentChannelId, commercialType]);

  useEffect(() => {
    if (legacy_token && currentCustomer) {
      getBotFlow();
    }
  }, [legacy_token, currentCustomer]);

  return {
    bots: filteredBotFlow,
    error,
    isLoading,
  };
}
